import script from "./DSPEvidenceGuidanceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DSPEvidenceGuidanceModal.vue?vue&type=script&setup=true&lang=js"

import "./DSPEvidenceGuidanceModal.vue?vue&type=style&index=0&id=78d85132&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d85132"]])

export default __exports__